var rtl_default = {
  "rtl": "Ajy8K",
  "ltr": "Mu0-d"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
